var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dokbot-component',{attrs:{"inputs":_vm.inputs,"time-id":_vm.timeId,"workflow-id":_vm.workflowId,"is-preview-mode":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }